import React from 'react';
import { makeStyles } from '@material-ui/core';
import { useHistory, useLocation } from 'react-router-dom';

import { Button, ButtonTypes } from 'app/components/Material/Inputs/Button';
import { BetaTag } from '../Common/BetaTag';
import clsx from 'clsx';
import {
  useIsTeamMenuFeatureEnabled,
  useIsConnectionsMenuEnabled,
} from 'app/utils/posthog';
import { isTeamAdmin } from 'app/utils/helpers';
import { removeCSSClass } from '_metronic/utils/utils';

const useStyles = makeStyles((theme) => ({
  menuItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '14px 24px',
    color: '#222',
    fontFamily: 'Manrope',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '20px' /* 142.857% */,
  },
  subMenu: {
    padding: '16px 0',
  },
  subName: {
    color: '#999',
    fontFamily: 'Manrope',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '16px' /* 133.333% */,
    letterSpacing: '0.12px',
    textTransform: 'uppercase',
    padding: '14px 24px',
  },
  menuSubItem: {
    padding: '14px 24px',
    cursor: 'pointer',
    color: '#222',
    fontFamily: 'Manrope',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '20px',
    position: 'relative',
    '&:hover': {
      background: 'var(--hover, rgba(86, 94, 237, 0.08))',
    },
  },
  isActive: {
    background: 'rgba(46, 49, 94, 0.08)',
  },
}));

export const MenuSettings = (props) => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();

  const { handleCloseSettings, lastPath, userDetails } = props;

  const isConnectionsMenuEnabled = useIsConnectionsMenuEnabled();

  const isTeamMenuFeatureEnabled = useIsTeamMenuFeatureEnabled();
  const isAdmin = isTeamAdmin(userDetails.parentUsers)

  const onClose = () => {
    handleCloseSettings();
    if (lastPath) {
      if (lastPath.includes('/settings')) {
        history.push('/keyword-spy');
      } else {
        history.push(lastPath);
      }
    } else {
      history.push('/keyword-spy');
    }
  };

  // Function to close sidebar on mobile
  const closeMobileSidebar = () => {
    const isMobile = window.innerWidth < 1025;
    if (isMobile) {
      const closeBtn = document.getElementById('kt_aside_close_btn');
      if (closeBtn) {
        closeBtn.click();
      }
      
      removeCSSClass(document.body, 'kt-aside--minimize-hover');
      removeCSSClass(document.body, 'kt-aside--on');
    }
  };

  const handleMenuItemClick = (page) => {
    history.push(page);
    closeMobileSidebar();
  };

  let companyMenu = []

  isAdmin && companyMenu.push(...[
    {
      label: 'Company Profile',
      page: '/settings/company-profile',
    },
    {
      label: 'Billing',
      page: '/settings/billing',
    },
  ])

  isTeamMenuFeatureEnabled && isAdmin &&
    companyMenu.push({
      label: 'Team',
      page: '/settings/team',
    });

  isConnectionsMenuEnabled && companyMenu.push({
    label: 'Connections',
    page: '/settings/connections',
    betaUser: true,
  });

  const userMenu = [
    {
      label: 'User Profile',
      page: '/settings/user-profile',
    },
  ];

  return (
    <div>
      <div className={classes.menuItem}>
        <span>Settings</span>
        <Button
          type={ButtonTypes.icon}
          icon="close"
          //   className={classes.close}
          onClick={onClose}
        />
      </div>
      <div className={classes.subMenu}>
        <div className={classes.subName}>COMPANY</div>
        {companyMenu.map((item, index) => (
          <div
            key={`company-menu-${index}`}
            onClick={() => handleMenuItemClick(item.page)}
            className={clsx(
              classes.menuSubItem,
              item.page === location.pathname && classes.isActive,
            )}
          >
            {item.betaUser && <BetaTag title="Beta" />}
            <span>{item.label}</span>
          </div>
        ))}
      </div>
      <div className={classes.subMenu}>
        <div className={classes.subName}>USER</div>
        {userMenu.map((item, index) => (
          <div
            key={`user-menu-${index}`}
            onClick={() => handleMenuItemClick(item.page)}
            className={clsx(
              classes.menuSubItem,
              item.page === location.pathname && classes.isActive,
            )}
          >
            <span>{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
